// extracted by mini-css-extract-plugin
export default {"modalOverlay":"cD-z","modalContent":"dD-z","header":"eD-z","close":"fD-z"};